import { InvoiceDetailSubscriptionModel } from './invoice-detail-subscription.model';
import { InvoiceDetailModel } from './invoice-detail.model';
import { MembershipModel } from './membership.model';
import { Association } from './assoication';
import { IndividualAffiliationModel } from './individual-affiliation.model';

export class CartModel {
  public InvoiceDetails: InvoiceDetailModel[] = [];
  public AdditionalInvoiceDetails: InvoiceDetailModel[] = [];
  public Memberships: MembershipModel[] = [];
  public ExistingMemberships: MembershipModel[] = [];
  public ExistingSubscriptions: InvoiceDetailSubscriptionModel[] = [];
  public ExistingDiscounts: InvoiceDetailModel[] = [];
  public ExistingAffiliations: IndividualAffiliationModel[] = [];
  public IsStudentUpgradeEligible: Association[] = [];
  public inv_key: string = undefined;
  public inv_cst_key: string = undefined;
  public inv_ind_cst_billing_key: string = undefined;
  public inv_src_key: string = undefined;
  public inv_code: string = undefined;
  public inv_orig_trans_type: 'prepaid' | 'installment payments' | 'terms'= undefined;
  public inv_trx_date: Date = undefined;
  public inv_student_upgrade_applied_flag_ext: boolean = undefined;
  public inv_nettotal: number = undefined;
  public inv_total: number = undefined;
  public inv_balance: number = undefined;
  public inv_netbalance: number = undefined;
  public inv_netpayment: number = undefined;
  public inv_netcredit: number = undefined;
  public pay_code: string = undefined;
  public pin_key: string = undefined;
  public pin_cpi_key: string = undefined;
  public pin_apm_key: string = undefined;
  public pin_cc_number_display: string = undefined;
  public pin_cc_expire: Date = undefined;
  public pin_cc_cardholder_name: string = undefined;
  public pin_check_amount: number = undefined;
  public pin_cc_auth: string = undefined;
  public pin_other_ref_number: string = undefined; 
  public pin_name_on_check?: string = undefined;
  public pin_eft_routing_number?: string = undefined;
  public pin_eft_account_number?: string = undefined;
  public pin_eft_account_number_display?: string = undefined;
  public pin_eft_account_type?: string = undefined;
  public apm_type?: string = undefined;
  public apm_method?: string = undefined;
  public ord_first_process_date: Date = undefined;
  public CustomerName: string = undefined;
  public BillToCustomerName: string = undefined;
  public cst_credit_available: number = undefined;

  public get isUpgrade(): boolean {

    return this.inv_student_upgrade_applied_flag_ext;
  }

  public get isInstallment(): boolean {
    return this.inv_orig_trans_type === 'installment payments';
  }

  public get FirstPayment(): number {
    return this.inv_netpayment;
  }

  public get FirstInstallment(): Date {
    return this.ord_first_process_date;
  }

  public get IsECPlus(): boolean {
    const ec = this.InvoiceDetails.some(ivd => ivd.prd_code === 'AExamCoach')
      || this.ExistingSubscriptions.some(ivd => ivd.prd_code === 'AExamCoach');

    const a5mm = this.InvoiceDetails.some(ivd => ivd.prd_code === 'A5mm');

    return ec && a5mm;
  }

  public get IsECPlusUpgrade(): boolean {
    const a5mm = this.InvoiceDetails.some(ivd => ivd.prd_code === 'A5mm');
    const other = this.InvoiceDetails.some(ivd => ivd.ivd_price > 0 && ivd.prd_code !== 'A5mm');

    return a5mm && !other;
  }

  public get Total(): number {
    let total = this.inv_nettotal;
    const credit = this.inv_netcredit;

    if (credit) {
      total -= credit;
    }

    return total;
  }

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'InvoiceDetails':
            case 'AdditionalInvoiceDetails':
            case 'ExistingDiscounts':
              const ivdKey: 'InvoiceDetails' | 'AdditionalInvoiceDetails' | 'ExistingDiscounts' = key as any;
              if (source[ivdKey] == null || source[ivdKey] === undefined) {
                this[ivdKey] = [];
              } else if (source[ivdKey] instanceof Array) {
                const ivdCollection: Array<any> = source[ivdKey];
                this[ivdKey] = ivdCollection.map(item => new InvoiceDetailModel(item));
              }
              break;
            case 'Memberships':
            case 'ExistingMemberships':
              const mbrKey: 'Memberships' | 'ExistingMemberships' = key as any;
              if (source[mbrKey] == null || source[mbrKey] === undefined) {
                this[mbrKey] = [];
              } else if (source[mbrKey] instanceof Array) {
                const mbrCollection: Array<any> = source[mbrKey];
                this[mbrKey] = mbrCollection.map(item => new MembershipModel(item));
              }
              break;
            case 'ExistingSubscriptions': {
              const trmKey: 'ExistingSubscriptions' = key as any;
              if (source[trmKey] == null || source[trmKey] === undefined) {
                this[trmKey] = [];
              } else if (source[trmKey] instanceof Array) {
                const trmCollection: Array<any> = source[trmKey];
                this[trmKey] = trmCollection.map(item => new InvoiceDetailSubscriptionModel(item));
              }
              break;
            }
            case 'ExistingAffiliations': {
              const trmKey: 'ExistingAffiliations' = key as any;
              if (source[trmKey] == null || source[trmKey] === undefined) {
                this[trmKey] = [];
              } else if (source[trmKey] instanceof Array) {
                const trmCollection: Array<any> = source[trmKey];
                this[trmKey] = trmCollection.map(item => new IndividualAffiliationModel(item));
              }
              break;
            }
            case 'inv_trx_date':
            case 'ord_first_process_date':
            case 'pin_cc_expire':
              const dateKey: 'inv_trx_date' | 'ord_first_process_date' | 'pin_cc_expire' = key as any;
              if (source[dateKey] == null || source[dateKey] === undefined || source[dateKey] === '') {
                this[dateKey] = null;
              } else {
                this[dateKey] = new Date(source[dateKey]);
              }
              break;
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
}
